import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { FormEditorComponent } from './form-editor.component';

@Injectable({ providedIn: 'root' })
export class FormEditorGuard implements CanDeactivate<FormEditorComponent> {
  canDeactivate(component: FormEditorComponent): Observable<boolean> | boolean {
    return component.saveIfDirty();
  }
}
